module.exports = __webpack_public_path__ + "static/media/9-stvlar.41e6ebf9.mp3";